// context/AppProviders.js
import React from 'react';
import { AuthProvider } from './AuthContext';
import { CompanyProvider } from './CompanyContext';

export const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <CompanyProvider>
        {children}
      </CompanyProvider>
    </AuthProvider>
  );
};